import React, { useRef } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../../redux/store';
import { useOnScrollToTop } from '../../../../hooks/useScrollToTop';
import BallastTankOperationsPrintView from './BallastTankOperationsPrint';
import BallastTankOperationsCoverPage from './BallastTankOperationsCoverPage';

type OwnProps = {
	showCoverPages?: boolean;
	vesselId: string;
};
type BallastTankOperationsInspectorViewProps = PropsFromRedux & OwnProps;

function BallastTankOperationsInspectorView(
	props: BallastTankOperationsInspectorViewProps
) {
	const { showCoverPages, vesselId } = props;
	const topDivRef = useRef<HTMLDivElement | null>(null);
	useOnScrollToTop(topDivRef);
	return (
		<div>
			<div className="h-0" ref={topDivRef} />
			{showCoverPages ? <BallastTankOperationsCoverPage vesselId={vesselId} /> : null}
			<BallastTankOperationsPrintView />
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BallastTankOperationsInspectorView);
